import { IAerialView } from '../../types/aerialView';

const DEFAULT_STATE: IAerialView = {
  placeholders: null,
};

export function aerialViewReducer(state: IAerialView = DEFAULT_STATE): IAerialView {
  return state;
}
